import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { DetailedCourseTitle, LearningTitle } from "../../../../Constants/Constants";
import LearningFilter from "../Common/LearningFilter";
import BlogDetails from "./BlogDetails/BlogDetails";
import { Fragment } from "react/jsx-runtime";

const DetailedCourseContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={DetailedCourseTitle} parent={LearningTitle} />
      <Container fluid>
        <Row>
          <BlogDetails />
          <LearningFilter />
        </Row>
      </Container>
    </Fragment>
  );
};
export default DetailedCourseContainer;
